export const chevronLeft16 = "M10.207 4l-4 4 4 4H8.793l-4-4 4-4z";
